
export default function orderQuery (query) {
    const {
        allContentfulDesign: { nodes },
        contentfulDesignPortfolioOrder: { order },
    } = query;
    let orderedPages = [];
    outer: for (let i = 0; i < order.length; i++) {
        let slugToFind = order[i].slug;
        for (let j = 0; j < nodes.length; j++) {
            let candidateSlug = nodes[j].slug;
            if (slugToFind === candidateSlug) {
                orderedPages.push(nodes[j]);
                continue outer;
            }
        }
    }
    return orderedPages
}